// var headerNav = require('../../shared/headerNav')
// var footer = require('../../shared/footer')
module.exports = {
  url: '/blog-post/:slug',
  template: require('raw!templates/blog-post/blog-post.html'),
  controller: NewsDetailController,
	controllerAs: 'newsDetailCtrl',
  params: {
    slug: null
  }
}

function NewsDetailController($scope, $state, store, contentful, $uibModal, $window, $timeout, $sce, $rootScope, Socialshare) {
    $window.scrollTo(0, 0);
  $rootScope.goBack = function() {
    $window.history.back();
  }
  $scope.page = 'blog-post'
  $scope.custom = true
  $scope.custom1 = false
  $scope.custom2 = true
  $scope.slide = {
    'blogNav': true
  }
  var vm = this;

  $scope.trustSrc = function(src) {
    return $sce.trustAsResourceUrl(src);
  }

  $rootScope.goBack = function() {
  $window.history.back();
}

var vm = this;
$window.scrollTo(0, 0);
vm.topics = [];
vm.gallery = [];
vm.authors = [];
vm.active = 0;
if ($state.params.slug) {
  var queryString = "content_type=blogPost&fields.slug=" + $state.params.slug;
  contentful.entries(queryString).then(function(res) {
    vm.currentNews = res.data.items[0];
    // console.log('currentnews', vm.currentNews)
    if (vm.currentNews) {

      if (vm.currentNews.fields.title) {
        document.title = 'Applied Building Sciences | Blog Post | ' + vm.currentNews.fields.title;
      }
      if (vm.currentNews.fields.title) {
        var meta = document.getElementsByTagName("meta");
        for (var i = 0; i < meta.length; i++) {
          if (meta[i].name.toLowerCase() === "description") {
            meta[i].content = vm.currentNews.fields.summary;
          }
          if (meta[i].name.toLowerCase() === "og:title") {
            meta[i].content = 'Applied Building Sciences | Blog Post | ' + vm.currentNews.fields.title;
          }
          if (meta[i].name.toLowerCase() === "og:description") {
            meta[i].content = vm.currentNews.fields.summary;
          }
          if (meta[i].name.toLowerCase() === "og:image") {
            meta[i].content = 'https:' + vm.currentNews.fields.image.fields.file.url;
          }
          if (meta[i].name.toLowerCase() === "og:image_src") {
            meta[i].content = 'https:' + vm.currentNews.fields.image.fields.file.url;
          }
          if (meta[i].name.toLowerCase() === "og:url") {
            meta[i].content = 'https://www.appliedbuildingsciences.com/blog-post/' + $state.params.slug
          }
          if (meta[i].name.toLowerCase() === "og:site_name") {
            meta[i].content = 'https://www.appliedbuildingsciences.com/blog-post/' + $state.params.slug
          }
        }
      }
    }
    if (vm.currentNews.fields.topics) {
      var topics = vm.currentNews.fields.topics
      topics.forEach(function(topic) {
        var queryString = "sys.id=" + topic.sys.id;
        contentful.entries(queryString).then(function(res) {
          vm.topics.push(res.data.items[0]);
        })
      })
    }

  });
}



vm.goToAuthor = function(author) {
  $state.go('news', {
    author: author.fields.name
  });
};
vm.goToTopic = function(topic) {
  $state.go('news', {
    newsTopic: topic.fields.topic
  });
};
  //
  // contentful.entries('content_type=blogPost').then(function(res) {
  //   vm.projectGallery = res.data.items[0];
  // });

  $scope.mainPage = 'blog-post'

  $timeout(function() {
    $('#lightgallery').lightGallery({pager: true});
    $('#html5-videos').lightGallery({});

    $('.responsive').slick({
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 800,
      slidesToShow: 4,

      // the magic
      responsive: [
        {

          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            infinite: true
          }

        }, {

          breakpoint: 600,
          settings: {
            slidesToShow: 2
          }

        }, {

          breakpoint: 400,
          settings: {
            slidesToShow: 1
          }

        }, {

          breakpoint: 300,
          settings: "unslick" // destroys slick

        }
      ]
    });
  }, 500);
  // social media icons test
  $scope.socialShare = function(share) {
    if (share === 'facebook') {
      Socialshare.share({
        'provider': 'facebook',
        'attrs': {
          'socialshareUrl': 'https://www.appliedbuildingsciences.com/blog-post/' + $state.params.slug,
          'socialshareQuote': vm.currentNews.fields.title,
          'socialsharePopupHeight': '600',
          'socialsharePopupWidth': '800'
        }
      });
    } else if (share === 'linkedin') {
      Socialshare.share({
        'provider': 'linkedin',
        'attrs': {
          'socialshareUrl': 'https://www.appliedbuildingsciences.com/blog-post/' + $state.params.slug,
          'socialshareText': vm.currentNews.fields.title,
          'socialshareMedia': vm.currentNews.fields.image.fields.file.url,
          'socialsharePopupHeight': '600',
          'socialsharePopupWidth': '800'
        }
      });
    }
  }
}



/** WEBPACK FOOTER **
 ** ./components/templates/blog-post/blog-post.js
 **/